import React from "react";
import construccion from "../../assets/images/construccion.jpg";

export function SettingsAdmin() {
  return (
    <div>
      <img src={construccion} alt="construccion" className="construccion"></img>
    </div>
  );
}
